import styled from 'styled-components'
import { ReactComponent as CloseIconSvg } from 'presentation/assets/icons/close.svg'

// export const ModalContent = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
// `

export const Header = styled.header`
  /* display: flex;
  align-items: center;
  margin-bottom: 2rem; */
`

export const CloseIcon = styled(CloseIconSvg)`
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-left: auto;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2.5rem;

  button {
    flex: 1;
  }
`

export const Content = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 4px;
  /* overflow-x: hidden; */

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.ds.colors.neutral300};
    border-radius: 4px;
  }

  /* Reset for desktop since it doesn't use the SheetModal in the same way */
  @media (min-width: 960px) {
    max-height: none;
    overflow-y: visible;
    padding-right: 0;
  }
`
